module.exports = "https://cdn.dove.it/_next/static/public/assets/channels/logo-subito.5fdedb8569e04e8bb6f546183e0c19fb.png";